import React, { useState, useEffect } from 'react';
import { Box, Button, ButtonGroup, TextField, Popover, Divider, Select, MenuItem, Typography } from '@mui/material';

import { useUnmountRegisterUserAction_msMutation } from '../../../../Redux/API/UnmountExecutionAPI';

import AlertDialog from '../../../Access/UI/AlertDialog';

function StateDescriptionEditPopover({ open, anchorEl, handleClose, stateDescriptionRowValue, user, setSnackBarMessage }) {
  const [stateEditValue, setStateEditValue] = useState('');
  const [stateDescriptionEditValue, setStateDescriptionEditValue] = useState('');
  const [UnmountRegisterUserAction] = useUnmountRegisterUserAction_msMutation();

  useEffect(() => {
    setStateDescriptionEditValue(stateDescriptionRowValue.unmounted_state_description);
    setStateEditValue(stateDescriptionRowValue.unmounted_state ?? 'Исправно');
  }, [open]);

  async function handlePopoverClose() {
    const res = await UnmountRegisterUserAction({
      action: 'save_state',
      user,
      checkedArr: [{ ...stateDescriptionRowValue, unmounted_state_description: stateDescriptionEditValue, unmounted_state: stateEditValue }],
    }).unwrap();
    handleClose();
    setSnackBarMessage(res.res);
  }

  return (
    <AlertDialog
      title='Вы уверены ?'
      response={() => {
        handlePopoverClose();
      }}
    >
      {(showAlertDialog) => (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={() => {
            if (stateDescriptionEditValue !== stateDescriptionRowValue.unmounted_state_description || stateEditValue !== stateDescriptionRowValue.unmounted_state)
              showAlertDialog();
            else handleClose();
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <Box sx={{ width: '400px' }}>
            <Box sx={{ marginTop: '5px' }}>
              <Typography sx={{ marginLeft: '10px' }} variant='caption'>
                Состояние:
              </Typography>

              <Select
                size='small'
                sx={{ margin: '0px 5px 5px 5px', width: '390px' }}
                value={stateEditValue}
                onChange={(event) => {
                  setStateEditValue(event.target.value);
                }}
              >
                <MenuItem value={'Неисправно, на утилизацию'}>Неисправно, на утилизацию</MenuItem>
                <MenuItem value={'Неисправно, в ремонт'}>Неисправно, в ремонт</MenuItem>
                <MenuItem value={'Исправно'}>Исправно</MenuItem>
              </Select>
            </Box>
            <Box>
              <Typography sx={{ marginLeft: '10px' }} variant='caption'>
                Описание неисправности:
              </Typography>

              <TextField
                multiline
                value={stateDescriptionEditValue}
                sx={{ margin: '0px 5px 5px 5px', width: '390px' }}
                onChange={(e) => {
                  setStateDescriptionEditValue(e.target.value);
                }}

                // sx={{ '& fieldset': { border: 'none' } }}
              />
            </Box>
            <Divider />
            <Box align='right'>
              <ButtonGroup size='small' sx={{ margin: '5px 5px 5px 0px' }}>
                <Button
                  sx={{ fontSize: '7px' }}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Отмена
                </Button>
                <Button
                  disabled={stateDescriptionEditValue === stateDescriptionRowValue.unmounted_state_description && stateEditValue === stateDescriptionRowValue.unmounted_state}
                  sx={{ fontSize: '7px' }}
                  onClick={() => {
                    showAlertDialog();
                  }}
                >
                  Сохранить
                </Button>
              </ButtonGroup>
            </Box>
          </Box>
        </Popover>
      )}
    </AlertDialog>
  );
}

export default StateDescriptionEditPopover;
